import { Component, OnInit, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { UserNotification } from 'projects/app-misc/src/app/modules/notification/data/user-notification';
import { NotificationService } from 'projects/app-misc/src/app/modules/notification/data/notification.service';
import { NotificationsQuery } from 'projects/app-misc/src/app/modules/notification/data/notifications.query';
import { Observable, Subject, combineLatest, timer, Subscription } from 'rxjs';
import { RecentNotificationsQuery } from 'projects/app-misc/src/app/modules/notification/data/recent-notifications.query';
import { map, share, debounceTime, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

@Component({
    selector: 'app-notification-panel',
    templateUrl: './notification-panel.component.html',
    styleUrls: ['./notification-panel.component.scss']
})
@RxJSUnsubscribe
export class NotificationPanelComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
    @Input()
    notificationOP: OverlayPanel

    notifications: UserNotification[] = [];

    limit = 4;


    recentNotifications$ = this.recentNotificationQuery.selectAll()
    recentCount$ = this.recentNotificationQuery.selectCount()
    totalUnreadCount$ = this.notificationQuery.totalUnread

    otherUnreadCount$: Observable<number>
  wsSub: Subscription;

    constructor(
        protected notificationService: NotificationService,
        protected notificationQuery: NotificationsQuery,
        protected recentNotificationQuery: RecentNotificationsQuery,
        protected wsService: WsService
    ) {
        const recentUnreadCount$ = this.recentNotifications$.pipe(
            map(recentNotifications => {
                return recentNotifications
                    .filter(notification => !notification.readStatus)
                    .length
            })
        )

        this.otherUnreadCount$ = combineLatest(recentUnreadCount$, this.totalUnreadCount$)
            .pipe(
                map(([recentUnreadCount, totalUnreadCount]) => totalUnreadCount - recentUnreadCount),
                share()
            )
    }

    ngOnInit() {
        this.updateNfs();

    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<Notification>>('/topic/update/model.notification.Notification', this)
            .pipe(
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.updateNfs();
            })

    }

    updateNfs() {
        this.notificationService.loadRecentNotifications(this.limit)
    }

    openNFPage() {
        this.notificationOP.hide()
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}
